const preloadedImages = new Map()

export const preloadImage = (src, action = () => {}) => {
  if (preloadedImages.has(src)) {
    return preloadedImages.get(src)
  }

  const promise = new Promise((resolve, reject) => {
    const image = new Image()
    image.onload = () => {
      action(image)
      resolve(image)
    }
    image.onerror = error => {
      resolve(false)
    }
    image.setAttribute('crossOrigin', 'anonymous')
    image.src = src
  })

  preloadedImages.set(src, promise)
  return promise
}
